import { CancelBroadbandScheduled } from "@features/CancelBroadband/CancelBroadbandScheduled/CancelBroadbandScheduled";
import { ITerminationRequestResponse } from "@pages/CancelBroadband/interface/ITerminationRequestResponse";
import { CancelBroadbandForm } from "@features/CancelBroadband/CancelBroadbandForm/CancelBroadbandForm";

interface IParams {
    terminationRequest: ITerminationRequestResponse | undefined;
    getTerminationRequest(): void;
}

export const CancelBroadband = (props: IParams) => {
    const { terminationRequest, getTerminationRequest } = props;

    if (terminationRequest?.scheduledAt) {
        return <CancelBroadbandScheduled scheduledAt={terminationRequest.scheduledAt} />;
    }

    return <CancelBroadbandForm getTerminationRequest={getTerminationRequest} />;
};
